/**
 * Created by Ning Jiang on 2019-01-09.
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {ThorGameAssets} from "../../ThorGameAssets";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ThorSoundConfig} from "../../ThorSoundConfig";
import {ThorFreeSpinIntroController} from "./ThorFreeSpinIntroController";

export class ThorFreeSpinIntroView extends ScreenView {

    private _container:PIXI.Container;
    private _banner:PIXI.Sprite;
    private _youWonText:PIXI.Text;
    private _numberOfSpinsText:PIXI.BitmapText;
    private _asgardSpinsText:PIXI.Sprite;
    private _numberOfSpins:number = 0;
    private _blackGfx:PIXI.Graphics;
    private _darkenBackground:PIXI.Graphics;


    constructor(config:IScreenViewConfig, autoClose:boolean = true) {
        super(config, autoClose);
    }


    protected initAnimations():void {

        super.initAnimations();

        this._blackGfx = new PIXI.Graphics();
        this._blackGfx.alpha = 0;
        this.addChild(this._blackGfx);
    }

    public updateText(numberOfSpins:number):void {
        this._numberOfSpins = numberOfSpins;
        this._numberOfSpinsText.text = "" + this._numberOfSpins;

        this._youWonText.anchor.set(0.5, 0.5);
        this._numberOfSpinsText.anchor = new PIXI.Point(0.5, 0.5);
        this._asgardSpinsText.anchor.set(0.5, 0.5);

        this._youWonText.position.set(0, -230);
        this._numberOfSpinsText.position.set(-25, -70);
        this._asgardSpinsText.position.set(0, 100);
    }

    protected createGameGraphics():PIXI.DisplayObject {
        const cont:PIXI.Container = new PIXI.Container();

        this._darkenBackground = new PIXI.Graphics();
        this._darkenBackground.alpha = 0.5;

        this._banner = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.FREE_SPIN_INTRO_OUTRO_BANNER)[0]);
        this._banner.anchor.set(0.5, 0.53);

        this._youWonText = new PIXI.Text(Translation.translate("YOU WON"), ThorGameConfig.TEXT_STYLES.FREESPIN_INTRO_YOU_WON);
        this._numberOfSpinsText = new PIXI.BitmapText("" + this._numberOfSpins, {
            fontName: ThorGameConfig.TEXT_STYLES.FREESPIN_INTRO_NUMBER.font.name!,
            fontSize: ThorGameConfig.TEXT_STYLES.FREESPIN_INTRO_NUMBER.font.size
        });
        this._asgardSpinsText = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.INTRO_BANNER_ASGARD_SPINS)[0]);


        cont.addChild(this._darkenBackground);
        cont.addChild(this._banner);
        cont.addChild(this._youWonText);
        cont.addChild(this._numberOfSpinsText);
        cont.addChild(this._asgardSpinsText);

        this._container = cont;

        return this._container;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
        this._container.scale.set(this._orientationScale, this._orientationScale);

        this._blackGfx.clear();
        this._blackGfx.beginFill(0x000000);
        this._blackGfx.drawRect(0, 0, this._screenWidth, this._screenHeight);
        this._blackGfx.endFill();

        this._darkenBackground.clear();
        this._darkenBackground.beginFill(0x000000);
        this._darkenBackground.drawRect(0, 0, this._screenWidth, this._screenHeight);
        this._darkenBackground.endFill();
        this._darkenBackground.position.set(-this._darkenBackground.width * 0.5, -this._darkenBackground.height * 0.5);
    }

    protected startPresentation(data:ParsedServerData, onShowComplete?:() => void):void {
        this._container.alpha = 0;
        this._button.alpha = 0;
        if(this._autoCloseTimer) {
            this._autoCloseTimer.alpha = 0;
        }

        this.updateText(data.freespinsLeft);
        this.alpha = 1;

        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this.playSound());
        tl.add(this.fadeInBlack());
        tl.add(() => ThorFreeSpinIntroController.actuallyDoTransition());
        tl.add(() => {
            this._container.alpha = 1;
            this._button.alpha = 1;

        });
        tl.add(this.fadeOutBlack());
        tl.add(() => {
            super.startPresentation(data, onShowComplete);
            if(this._autoCloseTimer) {
                this._autoCloseTimer.alpha = 1;
            }
        });
    }


    protected stopPresentation(closeCallback?:() => void):void {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(new TweenLite(this, 1, {alpha : 0, ease : Linear.easeNone}));
        timeline.add(() => super.stopPresentation(closeCallback));

    }

    private fadeInBlack():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this._blackGfx, 1, {alpha : 1, ease : Linear.easeNone}));
        return tl;

    }

    private fadeOutBlack():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this._blackGfx, 1, {alpha : 0, ease : Linear.easeNone}));
        return tl;
    }

    private playSound() {
        SlotGame.sound.playEffect(ThorSoundConfig.instance.FS_INTRO);
    }
}